import { useContext, useEffect, useRef, useState } from "react";
import HTMLBox from "./topAreaComponents/HTMLBox";
import CSSBox from "./topAreaComponents/CSSBox";
import JavascriptBox from "./topAreaComponents/JavascriptBox";
import { faCode } from "@fortawesome/free-solid-svg-icons";
import { faCss3, faJs } from "@fortawesome/free-brands-svg-icons";
import { DataContext } from "./DataProvider";

const TopArea = ({ cHeight }) => {
    const { viewPosition } = useContext(DataContext);
    const boxWidth = Math.round((window.innerWidth - 36) / 3);
    const boxHeight = Math.round((window.innerHeight - 6) / 3);
    const colSlide1 = useRef();
    const colSlide2 = useRef();

    // style ----
    const divStyle = {
        width: viewPosition ? cHeight ? `${cHeight}px` : "30%" : "100%",
        height: viewPosition ? "100%" : cHeight ? `calc(${cHeight}px - 60px)` : "50%",
        background: "#272c35",
        display: "flex",
        flexDirection: viewPosition ? "column" : "row",
        justifyContent: "space-between",
    }

    const boxStyle = {
        width: viewPosition ? "100%" : `calc((100% - 36px) / 3)`,
        height: viewPosition ? `calc((100% - 6px) / 3)` : "100%",
        border: "1px solid rgba(255,255,255, 0.2)",
        color: "rgba(120,120,120,1)",
        textTransform: "uppercase",
        overflow: "hidden",

        boxStyle: {
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            overflow: "hidden",
            cursor: viewPosition && "row-resize",

            button: {
                padding: "5px",
                fontSize: "20px",
                cursor: "pointer"
            },
            textDiv: {
                background: "#272c35",
                borderTop: "3px solid rgba(80,80,80,1)",
                width: "max-content",
                height: "max-content",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "8px",
                fontFamily: `"Encode Sans Expanded", sans-serif`,
                fontWeight: "600"
            },

            h1: {
                color: "rgb(200,200,200)",
                textOrientation: "sideways",
            }
        },
    }

    const toggleActive = {
        ...boxStyle.boxStyle,
        height: "max-content",
        flexDirection: "column",
        background: "#272c35",

        button: {
            ...boxStyle.boxStyle.button
        },
        textDiv: {
            ...boxStyle.boxStyle.textDiv,
            padding: "5px 10px",
            flexDirection: "column",
        },

        h1: {
            writingMode: "tb",
            ...boxStyle.boxStyle.h1,
        }
    };
    const toggleNone = {
        ...boxStyle.boxStyle,
        height: "42px",
        flexDirection: "row",
        background: "#0c0f1a",

        button: {
            ...boxStyle.boxStyle.button
        },
        textDiv: {
            ...boxStyle.boxStyle.textDiv,
            padding: "9px 10px",
            flexDirection: "row",
        },

        h1: {
            writingMode: "lr",
            ...boxStyle.boxStyle.h1,
        }
    }

    const moveBox = {
        width: viewPosition ? "0px" : "15px", background: "#0c0f1a", cursor: "col-resize"
    }

    const { html, setHtml, css, setCss, js, setJs, width1, setWidth1, width2, setWidth2, width3, setWidth3, toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3 } = useContext(DataContext);
    const [mousedown1, setMouseDown1] = useState(false);
    const [mousedown2, setMouseDown2] = useState(false);
    const [startPos, setStartPos] = useState(0);

    //functions-----
    // slide div handlers ----------
    const handleMouseDown1 = (event) => {
        setMouseDown1(true);
        setMouseDown2(false);
        setStartPos(event.clientX);
        setToggle1(null);
        setToggle2(null);
        setToggle3(null);
    }
    const handleMouseDown2 = (event) => {
        setMouseDown2(true);
        setMouseDown1(false);
        setStartPos(event.clientX);
        setToggle1(null);
        setToggle2(null);
        setToggle3(null);
    }

    const handleMouseDown3 = (event) => {
        setMouseDown1(true);
        setMouseDown2(false);
        setStartPos(event.clientY);
        if (event.clientX > 150 && event.clientX < event.target.clientWidth - 50 && viewPosition) {
            setToggle1(null);
            setToggle2(null);
            setToggle3(null);
        }
    }
    const handleMouseDown4 = (event) => {
        setMouseDown2(true);
        setMouseDown1(false);
        setStartPos(event.clientY);
        if (event.clientX > 150 && event.clientX < event.target.clientWidth - 50 && viewPosition) {
            setToggle1(null);
            setToggle2(null);
            setToggle3(null);
        }
    }

    useEffect(() => {
        const navbar = document.getElementById("navbar");
        const html = document.getElementById("html");
        const css = document.getElementById("css");
        const js = document.getElementById("js");
        const pos1 = !viewPosition ? Math.round(Math.abs(colSlide1.current.getBoundingClientRect().left - startPos)) : Math.round(Math.abs(css.getBoundingClientRect().top - startPos));
        html.style.transition = "0.2s";
        css.style.transition = "0.2s";
        js.style.transition = "0.2s";

        // toggle set
        let setWidthvalue = boxWidth * 0.435; // max 0.435
        // toggle functions ----------------------
        if (!viewPosition) {
            if (toggle1 === true) {
                setWidth1((boxWidth * 2) + (setWidthvalue * 2));
                setWidth2(-boxWidth * 0.5 - setWidthvalue)
                setWidth3(boxWidth * 0.5 + setWidthvalue)
            } else if (toggle1 === false) {
                setWidth1(0);
                setWidth2(0);
                setWidth3(0);
            }

            if (toggle2 === true) {
                setWidth1(boxWidth * 0.5 - setWidthvalue);
                setWidth2(boxWidth + setWidthvalue * 2)
                setWidth3(boxWidth * 0.5 + setWidthvalue)
            } else if (toggle2 === false) {
                setWidth1(0);
                setWidth2(0);
                setWidth3(0);
            }

            if (toggle3 === true) {
                setWidth1(boxWidth * 0.5 - setWidthvalue);
                setWidth2(-boxWidth * 0.5 - setWidthvalue)
                setWidth3(-boxWidth - (setWidthvalue * 2))
            } else if (toggle3 === false) {
                setWidth1(0);
                setWidth2(0);
                setWidth3(0);
            }
        } else {
            setWidthvalue = boxHeight * 0.25; // max 0.435
            if (toggle1 === true) {
                setWidth1((boxHeight * 2) + (setWidthvalue * 2));
                setWidth2(-boxHeight * 0.5 - setWidthvalue)
                setWidth3(boxHeight * 0.5 + setWidthvalue)
            } else if (toggle1 === false) {
                setWidth1(0);
                setWidth2(0);
                setWidth3(0);
            }

            if (toggle2 === true) {
                setWidth1(boxHeight * 0.5 - setWidthvalue);
                setWidth2(boxHeight + setWidthvalue * 2)
                setWidth3(boxHeight * 0.5 + setWidthvalue)
            } else if (toggle2 === false) {
                setWidth1(0);
                setWidth2(0);
                setWidth3(0);
            }

            if (toggle3 === true) {
                setWidth1(boxHeight * 0.5 - setWidthvalue);
                setWidth2(-boxHeight * 0.5 - setWidthvalue)
                setWidth3(-boxHeight - (setWidthvalue * 2))
            } else if (toggle3 === false) {
                setWidth1(0);
                setWidth2(0);
                setWidth3(0);
            }
        }

        const handleMouseUp = (event) => {
            setTimeout(() => {
                setMouseDown1(false);
                setMouseDown2(false);
            }, 10);
        }
        const handleDocumentmove = (event) => {
            html.style.transition = "0s";
            css.style.transition = "0s";
            js.style.transition = "0s";
            let lastBoxSize = 150;
            if (!viewPosition) {
                if (mousedown1) {
                    if ((html.clientWidth < lastBoxSize && event.clientX < lastBoxSize) || (css.clientWidth < lastBoxSize && event.clientX > colSlide2.current.getBoundingClientRect().left - lastBoxSize)) return;
                    setWidth1(event.clientX - pos1);
                    setWidth2(width2 + (startPos) - event.clientX);
                } else if (mousedown2) {
                    if ((css.clientWidth < lastBoxSize && event.clientX < colSlide1.current.getBoundingClientRect().left + 15 + lastBoxSize) || (js.clientWidth < lastBoxSize && event.clientX > window.innerWidth - lastBoxSize)) return;
                    setWidth2(width2 + event.clientX - startPos);
                    setWidth3(width3 + event.clientX - startPos)
                }
            } else {
                let clientY = event.clientY - navbar.clientHeight;
                if (mousedown1) {
                    if ((html.clientHeight < lastBoxSize && clientY < lastBoxSize) || (css.clientHeight < lastBoxSize && clientY > js.getBoundingClientRect().top - lastBoxSize)) return;
                    setWidth1(clientY - pos1);
                    setWidth2(width2 + (startPos) - event.clientY);
                } else if (mousedown2) {
                    if ((css.clientHeight < lastBoxSize && clientY < colSlide1.current.getBoundingClientRect().top + lastBoxSize) || (js.clientHeight < lastBoxSize && clientY > window.innerHeight - lastBoxSize)) return;
                    setWidth2(width2 + event.clientY - startPos);
                    setWidth3(width3 + event.clientY - startPos)
                }
            }
        }


        if (mousedown1 === true || mousedown2 === true) {
            document.addEventListener("mousemove", handleDocumentmove)
            document.addEventListener("mouseup", handleMouseUp)
        }
        return () => {
            document.removeEventListener("mousemove", handleDocumentmove);
            document.removeEventListener("mouseup", handleMouseUp)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mousedown1, mousedown2, toggle1, toggle2, toggle3]);

    // click functions
    const handleClick1 = () => {
        setToggle1(!toggle1);
        setToggle2(null);
        setToggle3(null);
    }

    const handleClick2 = () => {
        setToggle2(!toggle2);
        setToggle1(null);
        setToggle3(null);
    }

    const handleClick3 = () => {
        setToggle3(!toggle3);
        setToggle1(null);
        setToggle2(null);
    }

    return (
        <div style={divStyle}>
            <HTMLBox
                cStyle={[boxStyle, toggleNone, toggleActive]}
                // cStyle={boxStyle}
                icon={faCode}
                value={html}
                codeFunction={setHtml}
                cWidth={[width1, width2, width3]}
                toggle={[toggle1, toggle2, toggle3]}
                onHandleClick={handleClick1}
                viewPosition={viewPosition}
            />
            <div div style={moveBox} ref={colSlide1} onMouseDownCapture={handleMouseDown1}></div>
            <CSSBox
                cStyle={[boxStyle, toggleNone, toggleActive]}
                // cStyle={boxStyle}
                icon={faCss3}
                value={css}
                codeFunction={setCss}
                cWidth={[width1, width2, width3]}
                toggle={[toggle1, toggle2, toggle3]}
                onHandleClick={handleClick2}
                mousecaptuerEvent={handleMouseDown3}
                viewPosition={viewPosition}
            />
            <div style={moveBox} ref={colSlide2} onMouseDownCapture={handleMouseDown2}></div>
            <JavascriptBox
                cStyle={[boxStyle, toggleNone, toggleActive]}
                // cStyle={boxStyle}
                icon={faJs}
                value={js}
                codeFunction={setJs}
                cWidth={[width1, width2, width3]}
                toggle={[toggle1, toggle2, toggle3]}
                onHandleClick={handleClick3}
                mousecaptuerEvent={handleMouseDown4}
                viewPosition={viewPosition}
            />
        </div>
    );
}

export default TopArea;